<div class="room-details-container">
  <!-- Sección izquierda: Imagen y logo -->
  <div class="room-media">
    <div class="room-image-wrapper">
      <img [src]="detailRoomData?.roomImage" class="room-image" alt="Imagen de la habitación">
    </div>
    <div class="room-provider-logo">
      <img class="provider-logo" [src]="detailRoomData?.logoProvider" alt="Logo del proveedor">
    </div>
  </div>

  <!-- Sección derecha: Información de la habitación -->
  <div class="room-info-container">

    <!-- Fila 1: Capacidad, Condiciones, Tarifa por noche -->
    <div class="info-row">

      <!-- Capacidad -->
      <div class="info-col">
        <p class="info-title">Capacidad</p>
        <div class="info-content">
          <div class="info-item">
            <img src="../../../../../assets/icons/search-result/persona.svg" class="info-icon" alt="Adultos">
            <p class="info-text">{{ detailRoomData?.maxAdults }} Adultos</p>
          </div>
          <div class="info-item">
            <img src="../../../../assets/icons/search-result/hotel/infante.svg" class="info-icon-children" alt="Niños">
            <p class="info-text-children">{{ detailRoomData?.maxChildren }} Niños</p>
            <ng-container *ngIf="detailRoomData?.maxChildren > 0 && detailRoomData?.ageRangeChild && detailRoomData?.ageRangeChild.length > 0">
              <p class="info-text-children">({{ detailRoomData?.ageRangeChild[0] }} - {{ detailRoomData?.ageRangeChild[1] }}) años</p>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- Condiciones -->
      <div class="info-col">
        <p class="info-title-move">Condiciones</p>
        <div class="info-content">
          <ng-container *ngIf="detailRoomData?.rateClass == 'NR'">
            <p class="cancellation-nonrefundable">NO REEMBOLSABLE</p>
            <p class="cancellation-fee">100% Tarifa</p>
          </ng-container>
          <ng-container *ngIf="detailRoomData?.rateClass == 'R'">
            <p class="cancellation-refundable">REEMBOLSABLE</p>
            <p class="cancellation-policy-link" (click)="open()">Ver políticas</p>
          </ng-container>
        </div>
      </div>

      <!-- Tarifa por noche -->
      <div class="info-col">
        <div class="price-header">
          <p class="info-title-move">Tarifa por Noche</p>
          <div class="info-tool" *ngIf="detailRoomData?.dailyPrices?.length > 0 && detailRoomData?.dailyPrices[0].price">
            <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
            <span class="tooltip-info shadow-md" [ngStyle]="{ 'width.px': detailRoomData?.dailyPricesArr.length > 4 ? 105 : null }">
              <usb-daily-prices [dailyPrices]="detailRoomData?.dailyPricesArr" [currencies]="currencies" [currencyAgency]="currencyAgency" style="width: 100%"></usb-daily-prices>
            </span>
          </div>
        </div>
        <div class="price-value">
          <p class="price-amount-move" *ngIf="detailRoomData?.netPriceProf">
            {{ currencyAgency.code }}
            {{ detailRoomData?.netPriceProf | currencyConverterPure: detailRoomData?.currencyProduct : currencyAgency.code : currencies | number: '1.2-2' }}
          </p>
          <usb-tooltip-convert-amount
            [clientsSettingAppBooking]="clientSetting"
            [currencyProduct]="detailRoomData?.currencyProduct"
            [valueProduct]="detailRoomData?.netPriceProf">
          </usb-tooltip-convert-amount>
        </div>
        <p class="price-taxes-move">Imp. incluidos</p>
      </div>
    </div>

    <!-- Fila 2: Disponible, Régimen, Total Estadia -->
    <div class="info-row info-row-bottom">

      <!-- Disponible -->
      <div class="info-col">
        <p class="info-title">Disponible</p>
        <div class="info-content">
          <div class="info-item">
            <img src="../../../../assets/icons/search-result/hotel/filtro/CAMA.svg" class="info-icon-bed" alt="Habitaciones">
            <p class="info-text">{{ detailRoomData?.allotment }} Habitación(es)</p>
          </div>
        </div>
      </div>

      <!-- Régimen -->
      <div class="info-col">
        <p class="info-title-move">Régimen</p>
        <div class="info-content">
          <p class="info-text-move">{{ detailRoomData?.boardName }}</p>
        </div>
      </div>

      <!-- Total Estadia -->
      <div class="info-col">
        <p class="info-title-move">Total Estadia</p>
        <div class="price-value">
          <p class="price-amount-move" *ngIf="detailRoomData?.optionNightsNetTotalProf">
            {{ currencyAgency?.code }}
            {{ detailRoomData?.optionNightsNetTotalProf | currencyConverterPure: detailRoomData?.currencyProduct : currencyAgency.code : currencies | number: '1.2-2' }}
          </p>
          <usb-tooltip-convert-amount
            [clientsSettingAppBooking]="clientSetting"
            [currencyProduct]="detailRoomData?.currencyProduct"
            [valueProduct]="detailRoomData?.optionNightsNetTotalProf">
          </usb-tooltip-convert-amount>
        </div>
        <p class="price-taxes-move">Imp. incluidos</p>
      </div>
    </div>
  </div>
</div>
